import { FIELD_PAGE_SCROLL_WRAPPER_SELECTOR } from 'scripts/constants'

export default function showFullChildElement(element: HTMLDivElement) {
  const parent = element.closest<HTMLElement>(`.${FIELD_PAGE_SCROLL_WRAPPER_SELECTOR}`)
  const parentRect = parent?.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()
  const isFullyVisible = elementRect.top >= (parentRect?.top ?? 0) && elementRect.bottom <= (parentRect?.bottom ?? 0)

  if (!isFullyVisible) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
  }
}
